<div class="homepage">
    <section>
        <app-banner></app-banner>
    </section>
    <section id="trending-prop">
        <app-trending-properties></app-trending-properties>
    </section>
    <section id="app-features">
        <app-features></app-features>
    </section>     
    <div class="container">
	    <app-why-neprop></app-why-neprop>
    </div>
    <app-blogs></app-blogs>
</div>